// extracted by mini-css-extract-plugin
export default {"mn-choose-task-inspiration":"index_mn-choose-task-inspiration__6Gg0h"};